import React, { PropsWithChildren } from 'react';
import { Dialog } from 'radix-ui';

import styles from './drawer.module.scss';
interface DesktopDrawerProps {
  id?: string;
  className?: string;
  isOpen: boolean;
  onCancel: () => void;
  autoFocus?: boolean;
  mobileFullHeight?: boolean;
  onPointerDownOutside?: React.ComponentProps<typeof Dialog.Content>['onPointerDownOutside'];
}

export const Drawer: React.FC<PropsWithChildren<DesktopDrawerProps>> = ({
  id = 'drawer',
  className,
  isOpen,
  onCancel,
  autoFocus = true,
  children,
  mobileFullHeight,
  onPointerDownOutside,
}) => {
  const handleOpenChange = (value: boolean) => {
    if (!value) {
      onCancel();
    }
  };

  return (
    <Dialog.Root key={id} open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles['overlay']} />

        <Dialog.Content
          className={className ? `${styles['content']} ${className}` : styles['content']}
          data-full-height={mobileFullHeight}
          onPointerDownOutside={onPointerDownOutside}
          onInteractOutside={(e) => {
            // Keep the drawer open when interacting with dropdown menus that
            // portal outside it (react-select's body portal, `#dropdown-root`),
            // which are not part of Radix's layer tree.
            const target = e.target as HTMLElement | null;
            if (target?.closest('[class*="__menu-portal"], #dropdown-root')) {
              e.preventDefault();
            }
          }}
          onOpenAutoFocus={(e) => {
            if (!autoFocus) {
              e.preventDefault();
            }
          }}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
